import DynamicComponent from '@v4/common/components/atoms/DynamicComponent/DynamicComponent';

export default DynamicComponent;
